import React, { useEffect, useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'
import { agreeSupplierLawyerAPI } from '../../../../../api/supply/supplierAPI'
import { useDispatch } from 'react-redux'
import { editSupplierDisagreeLawyerText, editSupplierIsAgreeLawer } from '../../../../../store/supplierSlice'

const AgreeLawyerForm = ({ supplierBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplierBd ? 
            {
                isAgreeLawyer: supplierBd.isAgreeLawyer,
                disagreeLawyerText: supplierBd.disagreeLawyerText,
            } 
        : {}
    ) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplierLawyerAPI({
            id: supplierBd.id,
            isAgreeLawyer: data.isAgreeLawyer,
            disagreeLawyerText: data.disagreeLawyerText,
        }).then(data => {
            if (data) {
                dispatch(editSupplierIsAgreeLawer(data.isAgreeLawyer))
                dispatch(editSupplierDisagreeLawyerText(data.disagreeLawyerText))
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження підрядника юристом. Всі документи перевірено і з цим підрядником можна працювати
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplierAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplierAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeLawyer', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeLawyer', e)}
					forciblyValue={
                        data && data.isAgreeLawyer === true ? true :
                        data && data.isAgreeLawyer === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplierAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeLawyer === false || data.isAgreeLawyer === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplierAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeLawyerText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeLawyerText', e)}
					forciblyValue={data ? data.disagreeLawyerText : ''}
                    className={data && (data.isAgreeLawyer === false || data.isAgreeLawyer === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeLawyerForm